<template>
  <div class="location-fields">
    <div class="field">
      <label>País</label>
      <select :value="countryCode" class="loc-select" @change="onCountrySelect">
        <option value="">Selecione o país</option>
        <option v-for="opt in countryOptions" :key="opt.code" :value="opt.code">{{ opt.name }}</option>
      </select>
    </div>
    <div class="field city-field">
      <label>Cidade</label>
      <div class="city-wrap">
        <input
          type="text"
          :value="cityName"
          autocomplete="off"
          placeholder="Digite para buscar (ex.: Lisboa)"
          @input="onCityInput"
          @focus="cityOpen = cityResults.length > 0"
          @blur="scheduleCloseDropdown"
        />
        <ul v-if="cityOpen && (cityLoading || cityResults.length)" class="city-dd">
          <li v-if="cityLoading" class="muted">Buscando…</li>
          <li
            v-for="(r, i) in cityResults"
            v-else
            :key="`${r.name}-${r.countryCode}-${i}`"
            @mousedown.prevent="pickCity(r)"
          >
            <strong>{{ r.name }}</strong>
            <span class="sub">{{ r.admin1 ? `${r.admin1} · ` : "" }}{{ countryLabelFromCode(r.countryCode) || r.country }}</span>
          </li>
        </ul>
      </div>
      <small class="hint">A lista vem da API Open-Meteo (nomes em português quando disponível).</small>
    </div>
  </div>
</template>

<script>
import { getSortedCountryOptions, getCountryNamePt } from "../utils/countriesPt";
import { searchCitiesOpenMeteo } from "../utils/geoSearch";

export default {
  name: "LocationSelectFields",
  props: {
    cityName: { type: String, default: "" },
    countryLabel: { type: String, default: "" },
    countryCode: { type: String, default: "" },
  },
  emits: ["update:cityName", "update:countryLabel", "update:countryCode"],
  data() {
    return {
      citySearchDebounceTimer: null,
      countryOptions: getSortedCountryOptions(),
      cityQuery: "",
      cityResults: [],
      cityLoading: false,
      cityOpen: false,
    };
  },
  watch: {
    cityName(n) {
      if (n !== this.cityQuery) this.cityQuery = n;
    },
  },
  mounted() {
    this.cityQuery = this.cityName || "";
  },
  methods: {
    countryLabelFromCode(code) {
      return getCountryNamePt(code);
    },
    onCountrySelect(e) {
      const code = (e.target.value || "").toUpperCase();
      this.$emit("update:countryCode", code);
      this.$emit("update:countryLabel", code ? getCountryNamePt(code) : "");
      this.cityResults = [];
      this.cityOpen = false;
      if (this.cityQuery.length >= 2) this.runCitySearch();
    },
    onCityInput(e) {
      const v = e.target.value;
      this.cityQuery = v;
      this.$emit("update:cityName", v);
      this.debouncedSearch();
    },
    debouncedSearch() {
      clearTimeout(this.citySearchDebounceTimer);
      this.citySearchDebounceTimer = setTimeout(() => this.runCitySearch(), 320);
    },
    async runCitySearch() {
      const q = (this.cityQuery || "").trim();
      if (q.length < 2) {
        this.cityResults = [];
        this.cityOpen = false;
        return;
      }
      this.cityLoading = true;
      this.cityOpen = true;
      try {
        this.cityResults = await searchCitiesOpenMeteo(q, this.countryCode);
      } catch {
        this.cityResults = [];
      } finally {
        this.cityLoading = false;
      }
    },
    pickCity(r) {
      const code = (r.countryCode || "").toUpperCase();
      this.$emit("update:cityName", r.name || "");
      this.$emit("update:countryCode", code);
      this.$emit("update:countryLabel", code ? getCountryNamePt(code) : (r.country || ""));
      this.cityQuery = r.name || "";
      this.cityResults = [];
      this.cityOpen = false;
    },
    scheduleCloseDropdown() {
      setTimeout(() => {
        this.cityOpen = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
.location-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
label {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 11px;
  color: #94adc8;
  font-weight: 700;
}
.loc-select,
.city-wrap input {
  border: 1px solid #1e3352;
  border-radius: 10px;
  padding: 12px;
  font-size: 15px;
  width: 100%;
  box-sizing: border-box;
  background: #081526;
  color: #e2eaf4;
}
.city-wrap {
  position: relative;
}
.city-dd {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin: 4px 0 0;
  padding: 4px 0;
  list-style: none;
  background: #152338;
  border: 1px solid #1e3352;
  border-radius: 10px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.4);
  max-height: 220px;
  overflow-y: auto;
  z-index: 40;
}
.city-dd li {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #e2eaf4;
}
.city-dd li:hover {
  background: #1e3a8a;
}
.city-dd li.muted {
  color: #94adc8;
  cursor: default;
}
.city-dd .sub {
  display: block;
  font-size: 12px;
  color: #94adc8;
  font-weight: 500;
  margin-top: 2px;
}
.hint {
  color: #4a6080;
  font-size: 11px;
  margin-top: 4px;
}
</style>
